import React from 'react';
import { IListTextFilter, ListTextFilter } from './list-text';
import { TextFilter } from './text';
import { RangeFilter } from './range';
import { PowersFilter } from './powers';
import { LogRangeFilter } from './log-range';
import { SelectFilter } from './select';
import { TextRangeFilter } from './text-range';
import { WaterFilter } from './water';

import './style.scss';

export const ListTextWrapper: React.FC<IListTextFilter> = (props: IListTextFilter) => {
    const { filter } = props;
    // return filter.settingsFilter.select ? <SelectFilter {...props} /> : <ListTextFilter {...props} />;
    return [ 26, 24, 46 ].includes(filter.id) ? <SelectFilter {...props} /> : <ListTextFilter {...props} />;
};

export const Filters = {
    'list_text': ListTextWrapper,
    'text': TextFilter,
    // 'range': RangeFilter,
    'range': TextRangeFilter,
    'gas': PowersFilter,
    'powers': PowersFilter,
    // 'log_range': LogRangeFilter
    'log_range': TextRangeFilter,
    'water_supply': WaterFilter,
    'sewerage': WaterFilter
};

export type FilterComponentType = typeof ListTextFilter
    | typeof TextFilter
    | typeof RangeFilter
    | typeof SelectFilter;
